import styled, { css } from 'styled-components';
import { DropdownListItem, FInter, FlexBox } from '@brg/ui';
import { LayoutConst } from "core/modules";

export const SearchBarHolder = styled(FlexBox)``;

export const ProjectSearchBarRoot = styled(FlexBox)`
    font-size: 15px;
    line-height: 20px;
    column-gap: 7px;
    min-height: 24px;
    border: ${({ theme }) => theme.sortByBorder};
    background: ${({ theme }) => theme.sortByBg};
    ${DropdownListItem} {
        font-size: 15px;
        line-height: 20px;
        background: ${({ theme }) => theme.mainDropdownStyles.bg};
      
        div {
          color: ${({ theme }) => theme.mainDropdownStyles.color};

          .active {
            color: ${({ theme }) => theme.mainDropdownStyles.colorActive};
          }
        }

        &:hover {
          background: ${({ theme }) => theme.mainDropdownStyles.hoverBG};

          div {
            color: ${({ theme }) => theme.mainDropdownStyles.color};
          }
        }
    }

    .dropdown-element-popup {
      background: ${({ theme }) => theme.mainDropdownStyles.bg};
    }

    @media (max-width: ${LayoutConst.screen.m}px) {
      .dropdown-button {
        display: flex;
        align-items: center;
      }
    }
`

export const HoverItemWithSvg = styled(FInter.SmallTextFlex)`
    svg {
        opacity: 0.47;
        transition: opacity 0.2s;
    }
    &:hover {
        svg {
            opacity: 1;
        }
    }
`;

export const SortSmallTextDiv = styled(FInter.SmallTextDiv)`
    font-size: 17px;
    line-height: 22px;
    @media (max-width: ${LayoutConst.screen.mac13 }px), (max-height: ${LayoutConst.screen.height.projectCover}px) {
      font-size: 15px;
      line-height: 20px;
    }
`

export const HoverItemText = styled(FInter.SmallText)`
  letter-spacing: -0.02em;
  font-size: 17px;
  line-height: 22px;
  @media (max-width: ${LayoutConst.screen.mac13 }px), (max-height: ${LayoutConst.screen.height.projectCover}px) {
    font-size: 15px;
    line-height: 20px;
  }
`;

export const SearchBarWrapper = styled(FlexBox)<{inLine?: boolean }>`
    @media(max-width: ${LayoutConst.screen.sm}px) {
        flex-flow: column;
        place-items: flex-start;

        ${p => p?.inLine ? css`
            flex-flow: row;
            place-items: flex-start;

            * {
                margin-right: 0 !important;
            }

            ${SearchBarHolder} {
                max-width:inherit;
                width: auto;
            }
        ` : null}
    }
`;
import styled, { css } from 'styled-components';
import { DropdownListItem, FInter, FlexBox } from '@brg/ui';
import { LayoutConst } from "core/modules";

export const SearchBarHolder = styled(FlexBox)``;

export const ProjectSearchBarRoot = styled(FlexBox)`
    font-size: 15px;
    line-height: 20px;
    column-gap: 7px;
    min-height: 24px;
    border: ${({ theme }) => theme.sortByBorder};
    background: ${({ theme }) => theme.sortByBg};
    ${DropdownListItem} {
        font-size: 15px;
        line-height: 20px;
        background: ${({ theme }) => theme.mainDropdownStyles.bg};
      
        div {
          color: ${({ theme }) => theme.mainDropdownStyles.color};

          .active {
            color: ${({ theme }) => theme.mainDropdownStyles.colorActive};
          }
        }

        &:hover {
          background: ${({ theme }) => theme.mainDropdownStyles.hoverBG};

          div {
            color: ${({ theme }) => theme.mainDropdownStyles.color};
          }
        }
    }

    .dropdown-element-popup {
      background: ${({ theme }) => theme.mainDropdownStyles.bg};
    }

    @media (max-width: ${LayoutConst.screen.m}px) {
      .dropdown-button {
        display: flex;
        align-items: center;
      }
    }
`

export const HoverItemWithSvg = styled(FInter.SmallTextFlex)`
    svg {
        opacity: 0.47;
        transition: opacity 0.2s;
    }
    &:hover {
        svg {
            opacity: 1;
        }
    }
`;

export const SortSmallTextDiv = styled(FInter.SmallTextDiv)`
    font-size: 17px;
    line-height: 22px;
    @media (max-width: ${LayoutConst.screen.mac13 }px), (max-height: ${LayoutConst.screen.height.projectCover}px) {
      font-size: 15px;
      line-height: 20px;
    }
`

export const HoverItemText = styled(FInter.SmallText)`
  letter-spacing: -0.02em;
  font-size: 17px;
  line-height: 22px;
  @media (max-width: ${LayoutConst.screen.mac13 }px), (max-height: ${LayoutConst.screen.height.projectCover}px) {
    font-size: 15px;
    line-height: 20px;
  }
`;

export const SearchBarWrapper = styled(FlexBox)<{inLine?: boolean }>`
    @media(max-width: ${LayoutConst.screen.sm}px) {
        flex-flow: column;
        place-items: flex-start;

        ${p => p?.inLine ? css`
            flex-flow: row;
            place-items: flex-start;

            * {
                margin-right: 0 !important;
            }

            ${SearchBarHolder} {
                max-width:inherit;
                width: auto;
            }
        ` : null}
    }
`;
